import { createSlice } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '@doda/common/src/constants/loadingStatus';
import { RootState } from 'redux/store';
import { postRecommendModal } from './services/postRecommendModal';
import { RecommendModalState } from './services/recommendModal';

// 初期状態
export const recommendModalInitialState: RecommendModalState = {
  loading: LOADING_STATUS.IDLE,
  entity: {
    WSContainers: {},
    errors: [],
    results: 'success',
    resultInt: 1,
  },
};

/**
 * Recommend ModalのSliceを作成
 */
export const recommendModalSlice = createSlice({
  name: 'recommendModal',
  initialState: recommendModalInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(postRecommendModal.pending, (state) => {
      state.loading = LOADING_STATUS.PENDING;
    });
    builder.addCase(postRecommendModal.fulfilled, (state, action) => {
      state.loading = LOADING_STATUS.SUCCESS;
      state.entity = action.payload;
    });
    builder.addCase(postRecommendModal.rejected, (state) => {
      state.loading = LOADING_STATUS.ERROR;
    });
  },
});

// reducer
export const recommendModalReducer = recommendModalSlice.reducer;

/**
 * recommendModalSelector
 * @param state
 * @returns RecommendModalの現在の状態を返す
 */
export const recommendModalSelector = <S extends RootState>(state: S) =>
  state.recommendModal;
